import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArticleCard } from "../components/ArticleCard";
import { getCategory } from "../lib/categories";

export default function CategoryPage() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const c = getCategory(slug);

  useEffect(() => {
    setLoading(true);
    api.get("/articles", { params: { category: slug, limit: 50 } })
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10" data-testid={`category-page-${slug}`}>
      <div className="flex items-end justify-between border-b border-zinc-100 pb-6 mb-8">
        <div>
          <div className="font-outfit font-black uppercase tracking-widest text-xs bodh-text-gradient">Category</div>
          <h1 className="mt-1 font-devanagari font-black text-4xl sm:text-5xl text-zinc-900">{c.name_hi}</h1>
          <p className="mt-2 text-zinc-500 font-hind">{c.name_en} · {items.length} खबरें</p>
        </div>
        <Link to="/" className="text-sm font-outfit font-bold bodh-link">← Home</Link>
      </div>
      {loading ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-64 rounded-2xl bg-zinc-100 animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-24 font-devanagari text-zinc-500">इस श्रेणी में अभी कोई खबर नहीं है.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((a) => <ArticleCard key={a.id} a={a} size="md" />)}
        </div>
      )}
    </div>
  );
}
